const navMenuIcons = {
  windmill: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="40"
      fill="none"
      version="1.1"
      viewBox="0 0 32 40"
    >
      <g transform="translate(-.41 -.499)">
        <path
          fill="#606af8"
          d="M17.976 25.252l-.808 12.836h-3.753a2.817 2.817 0 00-2.532 1.564.613.613 0 00.27.827.503.503 0 00.27 0h18.512a.627.627 0 00.628-.61.757.757 0 000-.288 2.803 2.803 0 00-2.621-1.493h-3.735l-.377-5.932"
        />
        <path
          stroke="#23275b"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M31.694 33.9l-6.823-14.095a4.392 4.392 0 010-3.308l5.602-13.824a1.205 1.205 0 00-.736-1.582 1.202 1.202 0 00-1.436.413l-8.763 12.081a4.259 4.259 0 01-2.801 1.798l-14.778 2.3a1.185 1.185 0 00-.952 1.295v0a1.187 1.187 0 001.077 1.187l14.653 1.6a4.216 4.216 0 012.89 1.582l10.056 11.865a1.22 1.22 0 001.58.27v0a1.24 1.24 0 00.431-1.582z"
        />
      </g>
    </svg>
  ),
  plug: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="34"
      fill="none"
      version="1.1"
      viewBox="0 0 40 34"
    >
      <g clipPath="url(#clip0_102_22205)">
        <path
          fill="#5B70FF"
          d="M8.113 24.734A10.148 10.148 0 010 14.798V9.657a1.318 1.318 0 011.323-1.318h2.52V1.904A1.924 1.924 0 015.935.01 1.952 1.952 0 017.65 1.986V8.34h5.012V1.904A1.923 1.923 0 0114.75.01a1.953 1.953 0 011.712 1.976V8.34h2.515a1.318 1.318 0 011.318 1.318v5.14a10.147 10.147 0 01-8.113 9.937 8.422 8.422 0 01-4.064 0h-.005z"
        />
        <path
          stroke="#23275B"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="0.962"
          d="M39.34 16.693h-6.91a10.513 10.513 0 00-10.514 10.464c0 3.016-2.145 5.69-5.131 6.065a5.897 5.897 0 01-6.641-5.839v-5.26"
        />
      </g>
      <defs id="defs11">
        <clipPath id="clip0_102_22205">
          <path
            id="rect8"
            fill="#fff"
            d="M0 0H39.82V33.746H0z"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  code: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="42"
      height="31"
      fill="none"
      version="1.1"
      viewBox="0 0 42 31"
    >
      <g transform="translate(.003 .005)">
        <g clipPath="url(#clip0_102_22208)">
          <path
            stroke="#23275b"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.051"
            d="M26.618 21.265l6.094-6.099-5.422-5.421M35.68.52H6.314A5.779 5.779 0 00.535 6.299v18.386a5.779 5.779 0 005.779 5.779H35.68a5.779 5.779 0 005.778-5.779V6.3A5.779 5.779 0 0035.68.52z"
          />
          <path
            fill="#5b70ff"
            d="M25.284 6.924l-6.362 17.96a1.197 1.197 0 11-2.259-.798l6.357-17.96a1.203 1.203 0 012.264.798z"
          />
          <path
            stroke="#23275b"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.051"
            d="M15.387 9.745l-6.099 6.099 5.421 5.421"
          />
        </g>
      </g>
      <defs id="defs13">
        <clipPath id="clip0_102_22208">
          <path
            id="rect10"
            fill="#fff"
            d="M0 0H42V31.01H0z"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  conveyor: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="46"
      height="40"
      fill="none"
      version="1.1"
      viewBox="0 0 46 40"
    >
      <g clipPath="url(#clip0_102_22212)">
        <path
          fill="#5B70FF"
          d="M33.449 14.47l-1.867-1.381a7.728 7.728 0 000-1.908l1.867-1.382a1.89 1.89 0 00.514-2.434L32.516 4.79a1.82 1.82 0 00-2.363-.78l-2.091.975c-.48-.363-1-.672-1.547-.921l-.23-2.363A1.837 1.837 0 0024.452.018H21.56A1.837 1.837 0 0019.728 1.7l-.23 2.363a8.233 8.233 0 00-1.548.921l-2.109-.975a1.82 1.82 0 00-2.362.78l-1.447 2.575a1.89 1.89 0 00.52 2.434l1.866 1.382a7.728 7.728 0 000 1.908l-1.866 1.382a1.885 1.885 0 00-.514 2.433l1.44 2.576a1.82 1.82 0 002.363.78l2.097-.975a8.8 8.8 0 001.548.927l.23 2.363a1.843 1.843 0 001.831 1.689h2.894a1.843 1.843 0 001.831-1.69l.23-2.362a8.232 8.232 0 001.548-.921l2.091.974a1.82 1.82 0 002.363-.78l1.447-2.575a1.89 1.89 0 00-.502-2.44zM23 14.938a2.806 2.806 0 11-.011-5.612A2.806 2.806 0 0123 14.938z"
        />
        <path
          stroke="#23275B"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.181"
          d="M39.804 39.385H6.196a5.611 5.611 0 010-11.223h33.608a5.61 5.61 0 110 11.223z"
        />
        <path
          stroke="#23275B"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.181"
          d="M6.197 35.646a1.867 1.867 0 111.866-1.867 1.872 1.872 0 01-1.866 1.867v0z"
        />
        <path
          stroke="#23275B"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.181"
          d="M17.394 35.646a1.867 1.867 0 111.872-1.867 1.872 1.872 0 01-1.872 1.867z"
        />
        <path
          stroke="#23275B"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.181"
          d="M28.599 35.646a1.867 1.867 0 111.872-1.867 1.873 1.873 0 01-1.872 1.867v0z"
        />
        <path
          stroke="#23275B"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.181"
          d="M39.805 35.646a1.867 1.867 0 111.866-1.867 1.873 1.873 0 01-1.866 1.867v0z"
        />
      </g>
      <defs id="defs19">
        <clipPath id="clip0_102_22212">
          <path
            id="rect16"
            fill="#fff"
            d="M0 0H46V39.975H0z"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  gear: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="33"
      fill="none"
      version="1.1"
      viewBox="0 0 30 33"
    >
      <g clipPath="url(#clip0_102_22219)">
        <path
          stroke="#23275B"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.218"
          d="M28.392 19.199l-2.374-1.785a9.5 9.5 0 000-2.435l2.374-1.784a2.435 2.435 0 00.658-3.124l-1.827-3.306a2.338 2.338 0 00-3.044-.999l-2.685 1.249a11.026 11.026 0 00-1.991-1.218l-.299-3.045a2.363 2.363 0 00-2.35-2.167H13.17A2.363 2.363 0 0010.79 2.8l-.299 3.045A11.24 11.24 0 008.5 7.063L5.815 5.815a2.332 2.332 0 00-3.045.993L.907 10.12a2.436 2.436 0 00.694 3.075l2.375 1.784a9.498 9.498 0 000 2.436l-2.375 1.784a2.436 2.436 0 00-.657 3.123L2.8 25.628a2.326 2.326 0 003.044.999l2.685-1.218c.621.473 1.288.88 1.992 1.218l.298 3.045a2.362 2.362 0 002.35 2.112h3.714a2.362 2.362 0 002.32-2.192l.299-3.044a11.237 11.237 0 001.99-1.218l2.686 1.218a2.332 2.332 0 003.044-.999l1.858-3.306a2.435 2.435 0 00-.689-3.044z"
        />
        <path
          fill="#5B70FF"
          d="M14.997 19.795a3.598 3.598 0 100-7.197 3.598 3.598 0 000 7.197z"
        />
      </g>
      <defs id="defs11">
        <clipPath id="clip0_102_22219">
          <path
            id="rect8"
            fill="#fff"
            d="M0 0H30V32.399H0z"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  helmet: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="38"
      height="30"
      fill="none"
      version="1.1"
      viewBox="0 0 38 30"
    >
      <g clipPath="url(#clip0_102_22222)">
        <path
          stroke="#23275B"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.106"
          d="M37.446 25.31s-6.203 3.721-17.997 3.721c-11.793 0-17.997-3.72-17.997-3.72v-1.24a1.244 1.244 0 011.244-1.243h33.506a1.244 1.244 0 011.244 1.244v1.238z"
        />
        <path
          stroke="#23275B"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.106"
          d="M9.248 5.815a16.742 16.742 0 0120.397 0"
        />
        <path
          stroke="#23275B"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.106"
          d="M31.685 7.656a16.703 16.703 0 014.517 11.45v3.722H2.696v-3.721A16.72 16.72 0 017.208 7.662"
        />
        <path
          stroke="#23275B"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.106"
          d="M29.696 5.66l-3.009 10.043a1.239 1.239 0 00.831 1.541l.006.002a1.239 1.239 0 001.542-.83l3.009-10.043a1.238 1.238 0 00-.831-1.542l-.006-.001a1.239 1.239 0 00-1.542.83z"
        />
        <path
          stroke="#23275B"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.106"
          d="M7.661 4.838l-.005.002a1.239 1.239 0 00-.83 1.542l3.008 10.042a1.239 1.239 0 001.542.83l.005-.001a1.238 1.238 0 00.831-1.542L9.203 5.67a1.239 1.239 0 00-1.542-.83z"
        />
        <path
          fill="#5B70FF"
          d="M20.33 17.243h-1.758a2.488 2.488 0 01-2.472-2.211L14.79 3.244A2.494 2.494 0 0117 .479c.092-.005.185-.005.277 0h4.384a2.483 2.483 0 012.483 2.477v.277l-1.344 11.804a2.488 2.488 0 01-2.471 2.212v-.006z"
        />
      </g>
      <defs id="defs19">
        <clipPath id="clip0_102_22222">
          <path
            id="rect16"
            fill="#fff"
            d="M0 0H37.1V29.099H0z"
            transform="translate(.9 .49)"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  chart: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="41"
      fill="none"
      version="1.1"
      viewBox="0 0 40 41"
    >
      <g clipPath="url(#clip0_102_22230)">
        <path
          fill="#5B70FF"
          d="M38.81 19.096H22.174a1.19 1.19 0 01-1.19-1.19V1.19A1.19 1.19 0 0122.173 0 17.915 17.915 0 0140 17.905a1.19 1.19 0 01-1.19 1.19z"
        />
        <path
          stroke="#23275B"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="0.988"
          d="M24.071 37.065L18.637 22.46V6.942a1.113 1.113 0 00-1.122-1.127A16.981 16.981 0 00.475 22.663 17.04 17.04 0 0017.47 39.58c.38 0 .74 0 1.121-.045a15.97 15.97 0 004.783-1.032 1.12 1.12 0 00.696-1.438z"
        />
        <path
          stroke="#23275B"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="0.988"
          d="M26.783 36.739a.988.988 0 01-.939-.652l-4.94-13.197a.989.989 0 01.113-.919.988.988 0 01.82-.435H35.88a.988.988 0 01.988.988 15.199 15.199 0 01-9.713 14.131c-.118.05-.243.078-.37.084z"
        />
      </g>
      <defs id="defs13">
        <clipPath id="clip0_102_22230">
          <path
            id="rect10"
            fill="#fff"
            d="M0 0H40V40.074H0z"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  clipboard: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="29"
      height="37"
      fill="none"
      version="1.1"
      viewBox="0 0 29 37"
    >
      <g clipPath="url(#clip0_102_22234)">
        <path
          stroke="#23275B"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="0.971"
          d="M20.632 4.183h4.902a2.427 2.427 0 012.426 2.451V33.58a2.427 2.427 0 01-2.426 2.45H3.47a2.426 2.426 0 01-2.45-2.45V6.61a2.426 2.426 0 012.45-2.427h4.902"
        />
        <path
          stroke="#23275B"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="0.971"
          d="M12.382 1.708a2.426 2.426 0 014.241 0h1.558a2.427 2.427 0 012.451 2.427v1.228a1.22 1.22 0 01-1.228 1.247H9.601a1.223 1.223 0 01-1.228-1.223V4.183a2.427 2.427 0 012.45-2.426l1.559-.049z"
        />
        <path
          fill="#5B70FF"
          d="M6.927 23.538a2.024 2.024 0 012.859-2.854l1.528 1.519 7.692-8.542a2.04 2.04 0 013.422.427 2.04 2.04 0 01-.383 2.286l-9.12 10.134a2.032 2.032 0 01-1.455.67h-.073a2.038 2.038 0 01-1.427-.598l-3.043-3.042z"
        />
      </g>
      <defs id="defs13">
        <clipPath id="clip0_102_22234">
          <path
            id="rect10"
            fill="#fff"
            d="M0 0H27.939V36.515H0z"
            transform="translate(.53)"
          />
        </clipPath>
      </defs>
    </svg>
  )
};

const cardIcons = {
  windmill: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="38"
      fill="none"
      version="1.1"
      viewBox="0 0 32 38"
    >
      <g
        fill="#fff"
        fillOpacity="1"
        transform="translate(10.49 22)"
      >
        <g fill="#fff">
          <path
            fill="#fff"
            fillOpacity="1"
            d="M7.16.755L6.354 13.59H2.6a2.817 2.817 0 00-2.532 1.564.611.611 0 00.27.827.5.5 0 00.269 0H19.12a.628.628 0 00.628-.612.756.756 0 000-.287 2.802 2.802 0 00-2.622-1.492h-3.734l-.378-5.933"
          />
        </g>
        <path
          fill="none"
          stroke="#fff"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeOpacity="1"
          d="M20.794 12L13.971-2.095a4.39 4.39 0 010-3.308l5.602-13.824a1.206 1.206 0 00-.736-1.582 1.202 1.202 0 00-1.436.413L8.638-8.316a4.258 4.258 0 01-2.801 1.799l-14.778 2.3a1.185 1.185 0 00-.952 1.295v0a1.187 1.187 0 001.077 1.187l14.653 1.6a4.218 4.218 0 012.89 1.582l10.056 11.865a1.22 1.22 0 001.58.27v0A1.24 1.24 0 0020.795 12z"
        />
      </g>
    </svg>
  ),
  plug: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="39"
      height="33"
      fill="none"
      version="1.1"
      viewBox="0 0 39 33"
    >
      <path
        fill="#fff"
        d="M7.847 23.92a9.797 9.797 0 01-5.635-3.404A9.818 9.818 0 010 14.311V9.337a1.275 1.275 0 011.268-1.275h2.44V1.84A1.863 1.863 0 015.724.007a1.886 1.886 0 011.659 1.912v6.144h4.845V1.84A1.863 1.863 0 0114.245.007a1.885 1.885 0 011.65 1.912v6.144h2.429a1.273 1.273 0 011.273 1.275v4.973a9.822 9.822 0 01-2.21 6.202 9.8 9.8 0 01-5.628 3.408 8.125 8.125 0 01-3.926 0h.014z"
      />
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M38 16.143h-6.677a10.155 10.155 0 00-7.163 2.963 10.18 10.18 0 00-2.993 7.16c0 2.916-2.072 5.502-4.953 5.865a5.689 5.689 0 01-5.907-3.302 5.71 5.71 0 01-.509-2.345v-5.089"
      />
    </svg>
  ),
  code: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="30"
      fill="none"
      version="1.1"
      viewBox="0 0 40 30"
    >
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M25.22 20.263l5.658-5.663-5.034-5.034M33.634 1H6.366A5.366 5.366 0 001 6.366v17.073a5.366 5.366 0 005.366 5.366h27.268A5.366 5.366 0 0039 23.439V6.366A5.366 5.366 0 0033.634 1z"
      />
      <path
        fill="#fff"
        d="M23.98 6.946l-5.907 16.678a1.113 1.113 0 01-2.097-.741l5.902-16.678a1.117 1.117 0 012.103.741z"
      />
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M14.79 9.566l-5.658 5.663 5.039 5.035"
      />
    </svg>
  ),
  conveyor: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="34"
      fill="none"
      version="1.1"
      viewBox="0 0 40 34"
    >
      <path
        fill="#fff"
        d="M28.857 12.251l-1.583-1.171a6.55 6.55 0 000-1.618l1.582-1.171a1.602 1.602 0 00.436-2.063l-1.227-2.183a1.542 1.542 0 00-2.002-.66l-1.772.826a6.98 6.98 0 00-1.312-.781l-.195-2.003A1.557 1.557 0 0021.232 0h-2.454a1.557 1.557 0 00-1.552 1.427l-.195 2.003a6.981 6.981 0 00-1.312.78l-1.777-.826a1.542 1.542 0 00-2.003.661l-1.226 2.183a1.602 1.602 0 00.44 2.063l1.582 1.171a6.55 6.55 0 000 1.618l-1.582 1.171a1.598 1.598 0 00-.435 2.063l1.221 2.183a1.542 1.542 0 002.003.66l1.777-.826c.41.307.849.57 1.312.787l.195 2.002a1.562 1.562 0 001.547 1.422h2.454a1.562 1.562 0 001.552-1.432l.195-2.002a6.981 6.981 0 001.311-.782l1.773.827a1.543 1.543 0 002.003-.661l1.226-2.183a1.602 1.602 0 00-.43-2.058zM20 12.647a2.377 2.377 0 11-.01-4.755 2.377 2.377 0 01.01 4.755z"
      />
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M34.244 33.369H5.756a4.757 4.757 0 010-9.513h28.488a4.757 4.757 0 010 9.513v0z"
      />
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M5.756 30.2a1.582 1.582 0 110-3.165 1.582 1.582 0 010 3.165v0z"
      />
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M15.249 30.2a1.582 1.582 0 11.01-3.164 1.582 1.582 0 01-.01 3.164v0z"
      />
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M24.746 30.2a1.582 1.582 0 11.01-3.164 1.582 1.582 0 01-.01 3.164v0z"
      />
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M34.244 30.2a1.583 1.583 0 110-3.166 1.583 1.583 0 010 3.166v0z"
      />
    </svg>
  ),
  gear: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="35"
      height="38"
      fill="none"
      version="1.1"
      viewBox="0 0 35 38"
    >
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M33.21 22.478l-2.755-2.059c.121-.933.121-1.877 0-2.81l2.755-2.059a2.797 2.797 0 00.763-3.604l-2.12-3.815a2.709 2.709 0 00-1.536-1.272 2.726 2.726 0 00-1.996.12l-3.115 1.44a12.805 12.805 0 00-2.31-1.405l-.346-3.513a2.72 2.72 0 00-.873-1.779A2.75 2.75 0 0019.823 1h-4.274a2.75 2.75 0 00-1.894.73 2.72 2.72 0 00-.868 1.827l-.346 3.513c-.817.388-1.591.859-2.31 1.406l-3.116-1.44a2.72 2.72 0 00-1.994-.126 2.702 2.702 0 00-1.538 1.27l-2.161 3.822a2.797 2.797 0 00.805 3.548l2.755 2.059a10.9 10.9 0 000 2.81l-2.755 2.059a2.797 2.797 0 00-.763 3.604l2.155 3.815a2.695 2.695 0 001.534 1.277c.658.215 1.373.17 1.998-.125l3.115-1.405c.72.545 1.494 1.016 2.31 1.405l.346 3.513c.072.67.39 1.29.894 1.74a2.75 2.75 0 001.833.698h4.31a2.749 2.749 0 001.84-.744 2.72 2.72 0 00.85-1.785l.347-3.513a13.05 13.05 0 002.31-1.405l3.115 1.405a2.72 2.72 0 001.997.123 2.702 2.702 0 001.535-1.275l2.155-3.815a2.797 2.797 0 00-.798-3.513z"
      />
      <path
        fill="#fff"
        d="M17.669 23.166c2.305 0 4.175-1.859 4.175-4.152s-1.87-4.152-4.175-4.152c-2.306 0-4.175 1.859-4.175 4.152s1.869 4.152 4.175 4.152z"
      />
    </svg>
  ),
  helmet: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      fill="none"
      version="1.1"
      viewBox="0 0 40 40"
    >
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M38.434 30.422S32.08 34.233 20 34.233c-12.08 0-18.434-3.81-18.434-3.81v-1.27a1.274 1.274 0 011.275-1.274H37.16a1.274 1.274 0 011.274 1.275v1.268z"
      />
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M9.551 10.454a17.148 17.148 0 0120.892 0"
      />
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M32.533 12.34a17.109 17.109 0 014.627 11.728v3.811H2.84v-3.81a17.125 17.125 0 014.622-11.724"
      />
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M30.495 10.296L27.413 20.58c-.201.672.18 1.379.851 1.58l.005.001a1.269 1.269 0 001.58-.85l3.082-10.286a1.269 1.269 0 00-.851-1.58l-.006-.001a1.268 1.268 0 00-1.58.85z"
      />
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M7.927 9.454l-.006.001a1.269 1.269 0 00-.85 1.58l3.081 10.285a1.269 1.269 0 001.58.851l.005-.001a1.269 1.269 0 00.85-1.58L9.507 10.305a1.269 1.269 0 00-1.58-.851z"
      />
      <path
        fill="#fff"
        d="M20.9 22.16h-1.8a2.549 2.549 0 01-2.532-2.266L15.226 7.82A2.555 2.555 0 0117.49 4.99c.094-.006.189-.006.283 0h4.491a2.543 2.543 0 012.543 2.537v.283l-1.376 12.09a2.548 2.548 0 01-2.532 2.266v-.006z"
      />
    </svg>
  ),
  chart: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      fill="none"
      version="1.1"
      viewBox="0 0 40 40"
    >
      <path
        fill="#fff"
        d="M37.869 19.141H22.065a1.131 1.131 0 01-1.13-1.131V2.13A1.131 1.131 0 0122.064 1 17.02 17.02 0 0139 18.01a1.13 1.13 0 01-1.131 1.131z"
      />
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M23.868 36.212l-5.163-13.875V7.595a1.056 1.056 0 00-1.066-1.07A16.132 16.132 0 001.451 22.53 16.189 16.189 0 0017.597 38.6c.361 0 .704 0 1.065-.042a15.17 15.17 0 004.544-.981 1.068 1.068 0 00.662-1.366z"
      />
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M26.445 35.902a.938.938 0 01-.892-.62l-4.694-12.536a.938.938 0 01.108-.873.938.938 0 01.78-.413h13.339a.939.939 0 01.938.938 14.437 14.437 0 01-9.227 13.424 1.02 1.02 0 01-.352.08z"
      />
    </svg>
  ),
  clipboard: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="39"
      fill="none"
      version="1.1"
      viewBox="0 0 30 39"
    >
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M21.41 4.874h5.1a2.525 2.525 0 012.525 2.55v28.04a2.525 2.525 0 01-2.525 2.551H3.55A2.526 2.526 0 011 35.465V7.399a2.525 2.525 0 012.55-2.525h5.102"
      />
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12.824 2.298a2.524 2.524 0 014.414 0h1.62a2.525 2.525 0 012.551 2.525v1.278A1.272 1.272 0 0120.132 7.4H9.93a1.273 1.273 0 01-1.278-1.273V4.874a2.525 2.525 0 012.55-2.525l1.622-.05z"
      />
      <path
        fill="#fff"
        d="M7.147 25.015a2.106 2.106 0 012.974-2.97l1.591 1.581 8.006-8.888a2.122 2.122 0 113.161 2.823l-9.49 10.545a2.116 2.116 0 01-1.515.697h-.076a2.12 2.12 0 01-1.485-.621l-3.166-3.167z"
      />
    </svg>
  ),
  gears: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      fill="none"
      version="1.1"
      viewBox="0 0 40 40"
    >
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M27.352 16.088l-1.914-1.397a7.468 7.468 0 000-1.914l1.914-1.407a1.914 1.914 0 00.521-2.455l-1.478-2.603a1.833 1.833 0 00-2.393-.78l-2.115.98a8.797 8.797 0 00-1.56-.932l-.234-2.393a1.856 1.856 0 00-1.833-1.708h-2.934a1.861 1.861 0 00-1.851 1.698l-.23 2.393a8.664 8.664 0 00-1.565.933l-2.11-.98a1.838 1.838 0 00-2.393.78L5.722 8.914a1.914 1.914 0 00.522 2.455l1.885 1.397a7.465 7.465 0 000 1.914l-1.885 1.397a1.914 1.914 0 00-.522 2.455l1.46 2.599a1.833 1.833 0 002.393.784l2.11-.98c.486.373 1.01.694 1.565.957l.23 2.392a1.861 1.861 0 001.846 1.694h2.934a1.857 1.857 0 001.847-1.703l.234-2.393a8.794 8.794 0 001.56-.957l2.101 1a1.837 1.837 0 002.393-.785l1.435-2.603a1.914 1.914 0 00-.478-2.45zm-10.528.479a2.828 2.828 0 112.824-2.829 2.833 2.833 0 01-2.857 2.819l.033.01z"
      />
      <path
        fill="#fff"
        d="M33.922 27.573l-1.478.22a5.741 5.741 0 00-.407-.479 5.656 5.656 0 00-.479-.406l.22-1.48a1.216 1.216 0 00-.87-1.344l-1.819-.497a1.178 1.178 0 00-1.435.727l-.508 1.392a5.66 5.66 0 00-1.129.288l-1.187-.957a1.192 1.192 0 00-1.603.062l-1.316 1.32a1.177 1.177 0 00-.067 1.599l.957 1.191c-.134.364-.23.741-.287 1.125l-1.383.493a1.163 1.163 0 00-.722 1.435l.521 1.852a1.216 1.216 0 001.345.871l1.483-.22c.124.168.258.328.402.479.158.153.316.287.479.406l-.22 1.479a1.22 1.22 0 00.856 1.292l1.833.512a1.172 1.172 0 001.436-.723l.507-1.397a5.57 5.57 0 001.13-.282l1.186.957a1.187 1.187 0 001.603-.024l1.316-1.316a1.187 1.187 0 00.067-1.603l-.957-1.187c.135-.365.231-.744.287-1.13l1.373-.506a1.173 1.173 0 00.723-1.436l-.517-1.833a1.21 1.21 0 00-1.34-.88zm-4.546 4.972a1.804 1.804 0 11-2.551-2.55 1.804 1.804 0 012.551 2.55z"
      />
    </svg>
  ),
  lightning: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      fill="none"
      version="1.1"
      viewBox="0 0 40 40"
    >
      <path
        fill="#fff"
        d="M24.045 29.634a.69.69 0 00.857-.284l8.342-13.21a.69.69 0 00-.588-1.063h-5.571l2.065-8.201a.694.694 0 00-1.259-.54L19.57 19.557a.69.69 0 00.587 1.063h5.553l-2.065 8.206a.69.69 0 00.4.807z"
      />
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M14.169 38.003a1.086 1.086 0 001.348-.42l13.055-20.701a1.091 1.091 0 00-.933-1.67h-8.705L22.17 2.378a1.087 1.087 0 00-1.982-.844L7.166 22.235a1.09 1.09 0 00.932 1.669h8.682L13.544 36.74a1.086 1.086 0 00.625 1.263z"
      />
    </svg>
  ),
  robot: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      fill="none"
      version="1.1"
      viewBox="0 0 40 40"
    >
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M26.066 13.938H4.136a2.703 2.703 0 01-2.703-2.703v0a2.703 2.703 0 012.703-2.703h21.173"
      />
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M16.065 13.938l6.992 4.848a3.605 3.605 0 01.9 5.041 3.626 3.626 0 01-5.045.901L2.694 13.465"
      />
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M20.385 38.28H5.375l1.351-5.01h12.285l1.374 5.01z"
      />
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M17.335 27.03v6.24H8.42v-3.65"
      />
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M21.948 25.269L10.934 29.48a4.148 4.148 0 01-5.357-2.401 4.144 4.144 0 012.392-5.357l4.248-1.635"
      />
      <path
        fill="#fff"
        d="M23.764 12.655a2.703 2.703 0 003.69.9l1.374-.837.45-.289 4.956 1.712a1.663 1.663 0 002.023-.81l2.31-4.506a1.68 1.68 0 00-1.352-2.44 1.677 1.677 0 00-1.63.904l-1.626 3.203-4.23-1.473.63-4.433h3.56a1.707 1.707 0 001.72-1.617 1.676 1.676 0 00-1.671-1.74h-5.06a1.676 1.676 0 00-1.662 1.438l-.738 5.167-1.852 1.126a2.703 2.703 0 00-.901 3.694h.009z"
      />
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M20.917 23.485a1.67 1.67 0 001.667-1.672 1.67 1.67 0 00-1.667-1.671 1.67 1.67 0 00-1.667 1.671 1.67 1.67 0 001.667 1.672z"
      />
    </svg>
  )
};

const stepsIcons = {
  rocket: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="77"
      height="89"
      fill="none"
      version="1.1"
      viewBox="0 0 77 89"
    >
      <path
        fill="#5B70FF"
        d="M65.59 75.447c-1.51.005-3.01.262-4.436.761a9.574 9.574 0 00-6.523-6.213 9.592 9.592 0 00-8.8 1.943c.652-2.075.722-4.401-1.777-7.288a7.525 7.525 0 00-5.509-2.747 7.756 7.756 0 00-5.53 2.238 7.736 7.736 0 00-2.297 5.501 7.54 7.54 0 00.381 2.296 9.588 9.588 0 00-15.324 4.27 13.49 13.49 0 00-14.27 3.489A5.522 5.522 0 005.52 89H71.45a5.534 5.534 0 005.06-3.337 5.519 5.519 0 00-1.045-5.966 13.538 13.538 0 00-9.875-4.25z"
      />
      <path
        stroke="#23275B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M51.2 42.074l9.142 10.656a5.81 5.81 0 011.404 3.78v2.305a1.942 1.942 0 01-1.915 1.932 1.949 1.949 0 01-.965-.237l-11.71-6.506"
      />
      <path
        stroke="#23275B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M44.757 58.234a48.882 48.882 0 002.218-3.87 46.707 46.707 0 005.077-21.292 46.892 46.892 0 00-3.311-17.433"
      />
      <path
        stroke="#23275B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M28.25 15.639a47.192 47.192 0 004.013 42.575"
      />
      <path
        stroke="#23275B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M43.894 65.973H33.086a1.938 1.938 0 01-1.897-2.306l1.004-5.433h12.564l1.003 5.433a1.933 1.933 0 01-1.866 2.306v0z"
      />
      <path
        stroke="#23275B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M40.944 2.787c-.342-.401-.693-.792-1.004-1.183a1.916 1.916 0 00-2.79 0 45.335 45.335 0 00-8.85 14.035H48.74a45.474 45.474 0 00-7.797-12.852v0z"
      />
      <path
        stroke="#23275B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M25.79 42.074l-3.12 3.639-6.021 7.017a5.81 5.81 0 00-1.405 3.78v2.305a1.933 1.933 0 001.914 1.94c.338.003.67-.081.966-.245l8.329-4.642 3.362-1.864"
      />
    </svg>
  ),

  comments: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="81"
      height="66"
      fill="none"
      version="1.1"
      viewBox="0 0 81 66"
    >
      <path
        fill="#5B70FF"
        d="M1.81 46.83l3.07-9.61a2.25 2.25 0 00-.37-2A20.74 20.74 0 010 22.28C0 9.99 11 0 24.5 0S49 10 49 22.28c0 12.28-11 22.27-24.5 22.27a26.54 26.54 0 01-11.33-2.52 2.23 2.23 0 00-2 0l-9.36 4.8z"
      />
      <path
        stroke="#23275B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M66.64 58.98a2.57 2.57 0 00-2.25 0 30.45 30.45 0 01-13 2.88c-15.44 0-28-11.42-28-25.46 0-14.04 12.56-25.45 28-25.45s28 11.42 28 25.45a23.75 23.75 0 01-5.15 14.72 2.53 2.53 0 00-.42 2.34l3.5 11-10.68-5.48z"
      />
    </svg>
  ),
  people: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="84"
      height="77"
      fill="none"
      version="1.1"
      viewBox="0 0 84 77"
    >
      <path
        stroke="#23275B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M19.312 63.191a11.903 11.903 0 00-1.875-.995 8.214 8.214 0 002.615-2.983c.622-1.2.947-2.54.948-3.9a8.443 8.443 0 00-2.349-5.863A7.95 7.95 0 0012.972 47a7.86 7.86 0 00-3.102.618 8.054 8.054 0 00-2.634 1.8 8.331 8.331 0 00-1.762 2.702 8.532 8.532 0 00.332 7.099 8.223 8.223 0 002.62 2.985 12.02 12.02 0 00-5.393 4.523A12.568 12.568 0 001 73.578V75h15.698"
      />
      <path
        stroke="#23275B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M67.29 75H83v-1.422c0-2.443-.708-4.83-2.032-6.856a12.011 12.011 0 00-5.401-4.521c1.1-.76 2-1.785 2.623-2.987a8.504 8.504 0 00.951-3.907 8.442 8.442 0 00-2.368-5.874A7.957 7.957 0 0071.067 47a7.958 7.958 0 00-5.705 2.438A8.443 8.443 0 0063 55.316c.005 1.362.333 2.7.954 3.902a8.286 8.286 0 002.612 2.992c-.646.274-1.268.605-1.86.987"
      />
      <path
        fill="#5B70FF"
        stroke="#5B70FF"
        strokeMiterlimit="10"
        strokeWidth="2"
        d="M49.36 53.73a13.85 13.85 0 006.13-11.48 13.86 13.86 0 00-13.84-13.84 13.85 13.85 0 00-13.84 13.84 13.84 13.84 0 006.12 11.48 20.5 20.5 0 00-12.75 18.95v2.37h40.93v-2.37a20.5 20.5 0 00-12.75-18.95z"
      />
      <path
        stroke="#23275B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M41.65 20.96l9.89-8.79"
      />
      <path
        stroke="#23275B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M41.65 20.96l-9.89-8.79"
      />
      <path
        stroke="#23275B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M41.65 1v19.96"
      />
    </svg>
  ),
  comment: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="62"
      height="59"
      fill="none"
      version="1.1"
      viewBox="0 0 62 59"
    >
      <path
        stroke="#23275B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M47.28 52.49a2.7 2.7 0 00-2.4 0A32.55 32.55 0 0131 55.55c-16.54 0-30-12.24-30-27.28C1 13.23 14.46 1 31 1s30 12.23 30 27.27a25.45 25.45 0 01-5.55 15.81 2.69 2.69 0 00-.45 2.48l3 9.51a1 1 0 01-1.4 1.19l-9.32-4.77z"
      />
      <path
        fill="#5B70FF"
        d="M42.23 25.75a1.21 1.21 0 00-1-.82l-6.51-.59-2.58-6a1.19 1.19 0 00-2.2 0l-2.58 6-6.51.59a1.2 1.2 0 00-.68 2.1l4.92 4.31-1.45 6.4a1.19 1.19 0 00.46 1.24 1.2 1.2 0 001.32.06L31 35.67l5.62 3.36a1.22 1.22 0 001.32-.06 1.19 1.19 0 00.46-1.24L37 31.34l4.92-4.31a1.21 1.21 0 00.31-1.28z"
      />
    </svg>
  ),
  document: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="56"
      height="70"
      fill="none"
      version="1.1"
      viewBox="0 0 56 70"
    >
      <path
        stroke="#23275B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M54.55 18.96L37.06 1.47A1.51 1.51 0 0035.93 1H7.37A6.38 6.38 0 001 7.38v54.58a6.38 6.38 0 006.38 6.38h41.25A6.38 6.38 0 0055 61.96V20.08a1.569 1.569 0 00-.46-1.12h.01zm.45 1.06H38.55a2.39 2.39 0 01-2.39-2.35l-.23-16.62L55 20.02z"
      />
      <path
        stroke="#23275B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M9.55 51.29h16.22"
      />
      <path
        stroke="#23275B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M9.55 58.87H39.3"
      />
      <path
        fill="#5B70FF"
        d="M19 18.82a5.7 5.7 0 10-6.36 0 8.45 8.45 0 00-5.26 7.85v1h16.85v-1A8.44 8.44 0 0019 18.82z"
      />
    </svg>
  )
};

const accardionIcons = {
  chat: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="96"
      height="75"
      viewBox="0 0 96 75"
    >
      <defs>
        <linearGradient
          id="accordion-img1-a"
          x1="100%"
          x2="0%"
          y1="20.414%"
          y2="79.586%"
        >
          <stop offset="0%" stopColor="#23275B" />
          <stop offset="100%" stopColor="#494F94" />
        </linearGradient>
        <linearGradient
          id="accordion-img1-b"
          x1="100%"
          x2="0%"
          y1="20.291%"
          y2="79.709%"
        >
          <stop offset="0%" stopColor="#23275B" />
          <stop offset="100%" stopColor="#494F94" />
        </linearGradient>
      </defs>
      <g fill="none">
        <path
          fill="url(#accordion-img1-a)"
          d="M34.667 53.333c-6.834 0-13.184-1.55-18.55-4.166-3.634 2.116-8.684 4.166-14.784 4.166a1.305 1.305 0 01-1.216-.8 1.333 1.333 0 01.25-1.45c.05-.05 3.733-4.05 5.966-9.083C2.35 37.65 0 32.383 0 26.667 0 11.933 15.517 0 34.667 0c19.15 0 34.666 11.933 34.666 26.667 0 14.733-15.516 26.666-34.666 26.666z"
          opacity="0.4"
        />
        <path
          fill="url(#accordion-img1-b)"
          d="M96 48c0 5.717-2.35 11-6.333 15.333 2.233 5.05 5.916 9.034 5.966 9.084.367.39.465.96.25 1.45a1.313 1.313 0 01-1.216.8c-6.1 0-11.15-2.05-14.784-4.167-5.366 2.633-11.716 4.167-18.55 4.167-14.366 0-26.7-6.734-31.95-16.317a49.97 49.97 0 005.284.317c22.05 0 40-14.35 40-32 .003-1.12-.07-2.24-.217-3.35C87.083 27.3 96 36.85 96 48z"
        />
      </g>
    </svg>
  ),
  chatMobile: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="48"
      height="37"
      viewBox="0 0 96 75"
    >
      <defs>
        <linearGradient
          id="accordion-img1-a"
          x1="100%"
          x2="0%"
          y1="20.414%"
          y2="79.586%"
        >
          <stop offset="0%" stopColor="#23275B" />
          <stop offset="100%" stopColor="#494F94" />
        </linearGradient>
        <linearGradient
          id="accordion-img1-b"
          x1="100%"
          x2="0%"
          y1="20.291%"
          y2="79.709%"
        >
          <stop offset="0%" stopColor="#23275B" />
          <stop offset="100%" stopColor="#494F94" />
        </linearGradient>
      </defs>
      <g fill="none">
        <path
          fill="url(#accordion-img1-a)"
          d="M34.667 53.333c-6.834 0-13.184-1.55-18.55-4.166-3.634 2.116-8.684 4.166-14.784 4.166a1.305 1.305 0 01-1.216-.8 1.333 1.333 0 01.25-1.45c.05-.05 3.733-4.05 5.966-9.083C2.35 37.65 0 32.383 0 26.667 0 11.933 15.517 0 34.667 0c19.15 0 34.666 11.933 34.666 26.667 0 14.733-15.516 26.666-34.666 26.666z"
          opacity="0.4"
        />
        <path
          fill="url(#accordion-img1-b)"
          d="M96 48c0 5.717-2.35 11-6.333 15.333 2.233 5.05 5.916 9.034 5.966 9.084.367.39.465.96.25 1.45a1.313 1.313 0 01-1.216.8c-6.1 0-11.15-2.05-14.784-4.167-5.366 2.633-11.716 4.167-18.55 4.167-14.366 0-26.7-6.734-31.95-16.317a49.97 49.97 0 005.284.317c22.05 0 40-14.35 40-32 .003-1.12-.07-2.24-.217-3.35C87.083 27.3 96 36.85 96 48z"
        />
      </g>
    </svg>
  )
};

const benefitsIcons = {
  conditions: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="92"
      height="92"
      version="1.1"
      viewBox="0 0 92 92"
    >
      <g
        fill="none"
        fillRule="evenodd"
        stroke="none"
        strokeWidth="1"
      >
        <g transform="translate(-281 -1951)">
          <g transform="translate(282 1952)">
            <path
              stroke="#0e1c6b"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeOpacity="1"
              strokeWidth="2"
              d="M44.79 11.895c12.174 0 22.042 9.868 22.042 22.041 0 12.174-9.868 22.042-22.041 22.042S22.75 46.11 22.75 33.936c0-12.173 9.868-22.04 22.04-22.04z"
            />
            <path
              stroke="#0e1c6b"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeOpacity="1"
              strokeWidth="2"
              d="M.115 41.612C1.868 16.94 23.29-1.64 47.962.115 72.634 1.868 91.212 23.29 89.459 47.96c-1.753 24.672-23.175 43.25-47.847 41.498C16.94 87.706-1.638 66.284.115 41.612z"
            />
            <path
              stroke="#0e1c6b"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeOpacity="1"
              strokeWidth="2"
              d="M14.935 76.216C22.149 67.8 32.768 62.49 44.69 62.49c12.123 0 22.843 5.511 30.056 14.027"
            />
            <path
              fill="#5F6FFF"
              d="M52.505 38.946c0 4.308-3.507 7.714-7.714 7.714-4.208 0-7.715-3.506-7.715-7.714h15.429z"
            />
            <path
              stroke="#5F6FFF"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M52.505 38.946c0 4.308-3.507 7.714-7.714 7.714-4.208 0-7.715-3.506-7.715-7.714h15.429z"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  bonuses: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="71"
      height="92"
      version="1.1"
      viewBox="0 0 71 92"
    >
      <defs>
        <path
          id="path-1"
          d="M0 91.458L70.293 91.458 70.293 0 0 0z"
        />
      </defs>
      <g
        fill="none"
        fillRule="evenodd"
        stroke="none"
        strokeWidth="1"
      >
        <g transform="translate(-701 -1951)">
          <g transform="translate(701 1951)">
            <path
              stroke="#0e1c6b"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeOpacity="1"
              strokeWidth="2"
              d="M50.218 89.266a22.884 22.884 0 01-7.334 1.192H23.85c-15.149 0-26.1-14.487-21.971-29.054l7.313-25.8a20.453 20.453 0 0119.687-14.877h8.977a20.461 20.461 0 0119.688 14.878l6.943 24.847"
            />
            <path
              stroke="#0e1c6b"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeOpacity="1"
              strokeWidth="2"
              d="M26.444 20.747l-5.22-12.093C19.66 5.037 22.316 1 26.254 1H40.47c3.938 0 6.593 4.037 5.03 7.654l-5.22 12.093"
            />
            <mask id="mask-2" fill="#fff">
              <use xlinkHref="#path-1" />
            </mask>
            <path
              fill="#5F6FFF"
              d="M53.967 67.461L69.293 67.461 69.293 63.889 53.967 63.889z"
              mask="url(#mask-2)"
            />
            <path
              stroke="#5F6FFF"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M53.967 67.461L69.293 67.461 69.293 63.889 53.967 63.889z"
              mask="url(#mask-2)"
            />
            <path
              fill="#5F6FFF"
              d="M53.967 74.899L69.293 74.899 69.293 71.327 53.967 71.327z"
              mask="url(#mask-2)"
            />
            <path
              stroke="#5F6FFF"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M53.967 74.899L69.293 74.899 69.293 71.327 53.967 71.327z"
              mask="url(#mask-2)"
            />
            <path
              fill="#5F6FFF"
              d="M53.967 82.337L69.293 82.337 69.293 78.765 53.967 78.765z"
              mask="url(#mask-2)"
            />
            <path
              stroke="#5F6FFF"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M53.967 82.337L69.293 82.337 69.293 78.765 53.967 78.765z"
              mask="url(#mask-2)"
            />
            <path
              fill="#5F6FFF"
              d="M53.967 89.775L69.293 89.775 69.293 86.203 53.967 86.203z"
              mask="url(#mask-2)"
            />
            <path
              stroke="#5F6FFF"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M53.967 89.775L69.293 89.775 69.293 86.203 53.967 86.203z"
              mask="url(#mask-2)"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  food: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="102"
      height="92"
      version="1.1"
      viewBox="0 0 102 92"
    >
      <g
        fill="none"
        fillRule="evenodd"
        stroke="none"
        strokeWidth="1"
      >
        <g transform="translate(-1090 -1951)">
          <g transform="translate(1091 1952)">
            <path
              stroke="#0e1c6b"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeOpacity="1"
              strokeWidth="2"
              d="M56.962 43.182c2.113-2.814 3.074-6.329 2.814-9.904a15.45 15.45 0 01-.03-.962c0-7.92 6.85-14.24 14.952-13.369 5.928.641 10.835 5.278 11.777 11.166a14.3 14.3 0 01.15 3.115c-.29 4.296 1.152 8.592 4.256 11.586a25.332 25.332 0 017.751 18.267c0 14.3-11.807 25.847-26.218 25.406a24.21 24.21 0 01-14.01-4.436"
            />
            <path
              stroke="#0e1c6b"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeOpacity="1"
              strokeWidth="2"
              d="M72.945 18.767c0-6.66 1.582-12.999 4.446-18.767"
            />
            <path
              fill="#5F6FFF"
              d="M86.222 2.685c5.904-1.796 11.594-.288 12.706 3.368 1.112 3.656-2.773 8.077-8.68 9.873-5.904 1.796-11.593.288-12.705-3.368C76.43 8.9 80.316 4.48 86.221 2.685"
            />
            <path
              stroke="#5F6FFF"
              strokeWidth="2"
              d="M86.222 2.685c5.904-1.796 11.594-.288 12.706 3.368 1.112 3.656-2.773 8.077-8.68 9.873-5.904 1.796-11.593.288-12.705-3.368C76.43 8.9 80.316 4.48 86.221 2.685z"
            />
            <path
              stroke="#0e1c6b"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeOpacity="1"
              strokeWidth="2"
              d="M4.416 64.453l5.358-19.048a6.754 6.754 0 016.49-4.917h35.32a6.746 6.746 0 016.49 4.917l5.357 19.048"
            />
            <path
              stroke="#0e1c6b"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeOpacity="1"
              strokeWidth="2"
              d="M63.432 65.465l-5.358 19.047a6.754 6.754 0 01-6.49 4.918h-35.32a6.746 6.746 0 01-6.49-4.918L4.417 65.466"
            />
            <path
              stroke="#0e1c6b"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeOpacity="1"
              strokeWidth="2"
              d="M0 64.453L67.848 64.453"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  drinks: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="89"
      height="95"
      version="1.1"
      viewBox="0 0 89 95"
    >
      <g
        fill="none"
        fillRule="evenodd"
        stroke="none"
        strokeWidth="1"
      >
        <g transform="translate(-285 -2159)">
          <g transform="translate(289 2163)">
            <path
              fill="#5F6FFF"
              d="M26.219 13.11C26.219 5.87 20.35 0 13.109 0 5.869 0 0 5.87 0 13.11c0 7.24 5.869 13.11 13.109 13.11 7.241 0 13.11-5.87 13.11-13.11"
            />
            <path
              stroke="#5F6FFF"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="6.529"
              d="M26.219 13.11C26.219 5.87 20.35 0 13.109 0 5.869 0 0 5.87 0 13.11c0 7.24 5.869 13.11 13.109 13.11 7.241 0 13.11-5.87 13.11-13.11z"
            />
            <path
              stroke="#0e1c6b"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeOpacity="1"
              strokeWidth="2"
              d="M44.1459 46.8807L13.1089 13.1097 75.1819 13.1097z"
            />
            <path
              stroke="#0e1c6b"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeOpacity="1"
              strokeWidth="2"
              d="M44.146 46.881L44.146 89.425"
            />
            <path
              stroke="#0e1c6b"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeOpacity="1"
              strokeWidth="2"
              d="M30.145 89.424L58.147 89.424"
            />
            <path
              stroke="#0e1c6b"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeOpacity="1"
              strokeWidth="2"
              d="M26.67 27.862L61.412 27.862"
            />
            <path
              stroke="#0e1c6b"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeOpacity="1"
              strokeWidth="2"
              d="M46.5996 27.8621L70.0546 4.4171 83.7556 4.4171"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  training: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="65"
      height="92"
      version="1.1"
      viewBox="0 0 65 92"
    >
      <g
        fill="none"
        fillRule="evenodd"
        stroke="none"
        strokeWidth="1"
      >
        <g transform="translate(-704 -2162)">
          <g transform="translate(705 2163)">
            <path
              stroke="#0e1c6b"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeOpacity="1"
              strokeWidth="2"
              d="M31.7385 67.54895L43.3135 89.48695 50.1685 78.80295 62.8565 79.17395 50.9205 57.54695"
            />
            <path
              fill="#5F6FFF"
              d="M33.332 63.35l-13.79 26.137-6.855-10.683L0 79.174l11.765-22.83s1.111 4.748 10.757 1.862c5.147 8.22 10.81 5.144 10.81 5.144"
            />
            <path
              stroke="#5F6FFF"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M33.332 63.35l-13.79 26.137-6.855-10.683L0 79.174l11.765-22.83s1.111 4.748 10.757 1.862c5.147 8.22 10.81 5.144 10.81 5.144z"
            />
            <path
              stroke="#0e1c6b"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeOpacity="1"
              strokeWidth="2"
              d="M35.717 1.736l1.974 1.914a6.148 6.148 0 005.151 1.674l2.716-.38a6.164 6.164 0 016.935 5.04l.471 2.706a6.165 6.165 0 003.187 4.38l2.426 1.292a6.157 6.157 0 012.645 8.148l-1.202 2.465a6.18 6.18 0 000 5.412l1.202 2.465A6.155 6.155 0 0158.577 45l-2.426 1.293a6.165 6.165 0 00-3.187 4.38l-.47 2.705a6.164 6.164 0 01-6.936 5.041l-2.716-.38a6.156 6.156 0 00-5.15 1.673l-1.975 1.914a6.155 6.155 0 01-8.569 0l-1.974-1.914a6.145 6.145 0 00-5.15-1.674l-2.717.381a6.164 6.164 0 01-6.935-5.04l-.47-2.707a6.162 6.162 0 00-3.188-4.379L4.29 45a6.158 6.158 0 01-2.646-8.148l1.203-2.465a6.18 6.18 0 000-5.412L1.643 26.51a6.155 6.155 0 012.646-8.148l2.425-1.293a6.162 6.162 0 003.187-4.379l.471-2.706a6.164 6.164 0 016.935-5.04l2.716.38a6.159 6.159 0 005.151-1.674l1.974-1.914a6.154 6.154 0 018.57 0z"
            />
            <path
              stroke="#0e1c6b"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeOpacity="1"
              strokeWidth="2"
              d="M20.2737 33.93605L28.3107 41.97305 42.0807 22.82205"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  phone: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="53"
      height="92"
      version="1.1"
      viewBox="0 0 53 92"
    >
      <g
        fill="none"
        fillRule="evenodd"
        stroke="none"
        strokeWidth="1"
      >
        <g transform="translate(-1117 -2163)">
          <g transform="translate(1118 2164)">
            <path
              fill="#5F6FFF"
              d="M37.133 1.934l-.38 2.415a4.027 4.027 0 01-3.979 3.397h-15.15a4.026 4.026 0 01-3.977-3.397l-.38-2.415V0h23.866v1.934z"
            />
            <path
              stroke="#5F6FFF"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M37.133 1.934l-.38 2.415a4.027 4.027 0 01-3.979 3.397h-15.15a4.026 4.026 0 01-3.977-3.397l-.38-2.415V0h23.866v1.934z"
            />
            <path
              stroke="#0e1c6b"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeOpacity="1"
              strokeWidth="2"
              d="M41.512 89.468H8.877C3.978 89.468 0 85.49 0 80.588V8.877C0 3.978 3.978 0 8.877 0h32.635c4.9 0 8.878 3.978 8.878 8.877V80.59c0 4.9-3.968 8.877-8.878 8.877h0z"
            />
            <path
              stroke="#0e1c6b"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeOpacity="1"
              strokeWidth="2"
              d="M37.618 32.315L12.781 57.152"
            />
            <path
              stroke="#0e1c6b"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeOpacity="1"
              strokeWidth="2"
              d="M37.618 49.233L29.699 57.152"
            />
          </g>
        </g>
      </g>
    </svg>
  )
};

export {
  navMenuIcons,
  cardIcons,
  stepsIcons,
  accardionIcons,
  benefitsIcons
};
